<div>
  @if (invoiceId && tenantId) {
    <app-checkout
      [invoiceId]="invoiceId"
      [tenantId]="tenantId"
      [isAPI]="true"
    ></app-checkout>
  } @else {
    <div class="text-error">
      <p>Unable to load invoice. URL is invalid.</p>
    </div>
  }
</div>
